class AudioManager {

  constructor(application) {

    this.application = application;

    this.incomingMessageSound = new Audio(`${import.meta.env.REACT_APP_ASSETS_URL}/assets/audios/incoming-message-sound.mp3`);

  }

}

export default AudioManager;